// @ts-ignore
 
import request from "src/lib/axios";

/** 分页查询资产类目（扁平，默认仅根节点） GET /api/v1/asset-categories */
export async function AssetCategoryControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetCategoryControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAssetCategoryDtoArray>(
    "/api/v1/asset-categories",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建资产类目 POST /api/v1/asset-categories */
export async function AssetCategoryControllerCreateV1(
  body: MyApi.CreateAssetCategoryDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAssetCategoryDto>(
    "/api/v1/asset-categories",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 查询资产类目详情 GET /api/v1/asset-categories/${param0} */
export async function AssetCategoryControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetCategoryControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputAssetCategoryDto>(
    `/api/v1/asset-categories/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新资产类目 PUT /api/v1/asset-categories/${param0} */
export async function AssetCategoryControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetCategoryControllerUpdateV1Params,
  body: MyApi.UpdateAssetCategoryDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputAssetCategoryDto>(
    `/api/v1/asset-categories/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除资产类目（软删除） DELETE /api/v1/asset-categories/${param0} */
export async function AssetCategoryControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetCategoryControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/asset-categories/${param0}`,
    {
      method: "DELETE",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 查询资产类目树（全量） GET /api/v1/asset-categories/tree */
export async function AssetCategoryControllerTreeV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputAssetCategoryTreeDtoArray>(
    "/api/v1/asset-categories/tree",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
